import React, { useState, useCallback } from 'react';
import { useWatch } from 'react-hook-form';
import ProductSubForm from './ProductForm';
import FormBuilder from './FormBuilder';
import { v4 as uuidv4 } from "uuid";

export default function useSpecial({ control, register, editdata, setValue, errors }) {
  const [schema, setSchema] = useState(editdata?.schema || [{id: uuidv4(), type: "mobile", label: "Mobile", name: "mobile", required: true, options: []}]);
  // Watch the "special" checkbox value in real-time
  const isSpecialEnabled = useWatch({
    control,
    name: "special",
    defaultValue: editdata?.special === 1 
  });
  const renderSpecialForm = useCallback(() => {
    return (
      <div>
        {/* Toggle Switch Container */}
        <div className="row mx-2" style={{ marginBottom: '15px' }}>
          <div className="form-check form-switch"> 
            <input
              className="form-check-input"
              type="checkbox"
              id="special-toggle"
              // Use defaultChecked for initialization, RHF handles the rest
              defaultChecked={editdata?.special === 1}
              {...register("special")}
              style={{ cursor: 'pointer' }}
            />
            <label className="form-check-label" htmlFor="special-toggle" style={{ fontWeight: 'bold', cursor: 'pointer' }}>
              {isSpecialEnabled ? "In App Form Configuration Enabled" : "Enable In App Form Configuration?"}
            </label>
          </div>
        </div>

        {/* CONDITIONAL RENDERING: Only show if checkbox is TRUE */}
        {isSpecialEnabled && (
          <div style={styles.fadeContent}>
            <div style={{ marginBottom: '20px' }}>
              <ProductSubForm editdata={editdata} register={register} errors={errors} setValue={setValue} control={control} />
            </div>

            <div style={{ borderTop: '2px dashed #eee', paddingTop: '20px' }}>
              <h4 style={{ fontSize: '0.9rem', color: '#666', marginBottom: '10px' }}>Dynamic Field Builder</h4>
              <FormBuilder schema={schema} setSchema={setSchema} />
            </div>
          </div>
        )}
      </div>
    );
  }, [control, register, editdata, schema, isSpecialEnabled, errors]);

  return {
    schema,
    setSchema,
    SpecialForm: renderSpecialForm
  };
}

const styles = {
  fadeContent: {
    animation: 'fadeIn 0.3s ease-in',
  }
};